import { defineComponent as _defineComponent } from 'vue'
import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import {
    onMounted,
    ref,
    watch,
    computed,
  } from "vue";
  import ToggleButton from "@/components/ui/ToggleButton.vue";
  import { formatPrice } from "@/helpers/transformation/price";
  import { FacadeInterface } from "@/types/FacadeInterface";
  import { BuilderQuote } from "@/types/BuilderQuote";

  interface Props {
    selectedHouseDesign: HouseDesignInterface;
    quote: BuilderQuote | undefined;
  }
  const INITIAL_FACADE_COUNT = 3;

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderSelectFacade',
  props: {
    selectedHouseDesign: {},
    quote: {}
  },
  emits: ["update:selectedFacade"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;

  const isSliderOpen = ref(false);
  const fadeInEffect = ref(false);
  const selectedFacadeId = ref<string | null>(null);
  const selectedFacadeIds = ref<{ [key: string]: boolean }>({});
  const facadeDefault = ref<FacadeInterface | null>(null);
  const isMoreClicked = ref(false);
  const openFacadeSlider = () => {
    isSliderOpen.value = !isSliderOpen.value;

    setTimeout(() => {
      fadeInEffect.value = !fadeInEffect.value;
    }, 50);
  };

  const updateSelectedFacade = (facade: FacadeInterface, value: boolean) => {
    if (!value && facadeDefault.value?._id) {
      const facadeDefaultId = facadeDefault.value._id;

      selectedFacadeIds.value[facadeDefaultId] = true;
      selectedFacadeId.value = facadeDefaultId;
      emits("update:selectedFacade", facadeDefault.value);
    } else if (selectedFacadeId.value) {
      selectedFacadeIds.value[selectedFacadeId.value] = false;
      selectedFacadeId.value = facade._id;
      emits("update:selectedFacade", facade);
    }

    selectedFacadeIds.value[facade._id] = value;
  };

  watch(
    selectedFacadeIds,
    (newValue) => {
      const defaultFacadeId = props.selectedHouseDesign.facades.find(
        (facade) => facade.url === props.selectedHouseDesign.mainImages[0]
      )?._id;

      const allFalse = Object.values(newValue).every((selected) => !selected);

      if (allFalse && defaultFacadeId) {
        selectedFacadeIds.value[defaultFacadeId] = true;
      }
    },
    { deep: true }
  );

  const showMoreButton = computed(() => {
    return (
      props.selectedHouseDesign?.facades.length > INITIAL_FACADE_COUNT &&
      !isMoreClicked.value
    );
  });

  const visibleFacades = computed(() => {
    const INITIAL_VISIBLE_COUNT = INITIAL_FACADE_COUNT;

    return isMoreClicked.value
      ? props.selectedHouseDesign?.facades || []
      : props.selectedHouseDesign?.facades.slice(0, INITIAL_VISIBLE_COUNT) ||
          [];
  });

  const handleMoreClick = () => {
    isMoreClicked.value = true;
  };

  const isNoAdditionalCharge = (price: number | null | undefined | string) => {
    return (
      price === 0 || price === null || price === undefined || price === "0"
    );
  };

  const initializeFacades = (design: HouseDesignInterface) => {
    let defaultFacade = design.facades.find(
      (facade) =>
        props.quote && facade.url === props.quote.selections.facade.url
    );

    if (!defaultFacade) {
      defaultFacade = design.facades[0];
    }

    if (defaultFacade) {
      facadeDefault.value = defaultFacade;
      design.facades.forEach((facade) => {
        selectedFacadeIds.value[facade._id] = facade._id === defaultFacade?._id;
      });
      selectedFacadeId.value = defaultFacade._id;
      emits("update:selectedFacade", defaultFacade);
    }
  };

  watch(
    () => props.selectedHouseDesign,
    (newDesign) => {
      initializeFacades(newDesign);
    },
    { immediate: true }
  );

  onMounted(() => {
    initializeFacades(props.selectedHouseDesign);
  });

const __returned__ = { props, emits, isSliderOpen, fadeInEffect, selectedFacadeId, selectedFacadeIds, facadeDefault, isMoreClicked, INITIAL_FACADE_COUNT, openFacadeSlider, updateSelectedFacade, showMoreButton, visibleFacades, handleMoreClick, isNoAdditionalCharge, initializeFacades, get HouseDesignInterface() { return HouseDesignInterface }, onMounted, ref, watch, computed, ToggleButton, get formatPrice() { return formatPrice }, get FacadeInterface() { return FacadeInterface }, get BuilderQuote() { return BuilderQuote } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})